<template>
  <div class="banner" :style="{backgroundImage:`url(${list[0]})`}">
<!--        <van-swipe>
            <van-swipe-item>
                <img :src="list[0]" />
            </van-swipe-item>
        </van-swipe>-->
    </div>
</template>

<script>
export default {
    data() {
        return {
            // list: [require("@/assets/bg.jpg")],
          list: [require("@/assets/nbg.jpg")],
        };
    },
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  margin-top: 60px;
  margin-bottom: 10px;
  height: 156px;
  position: relative;
  background-repeat: no-repeat;
  background-size:100%;
  background-position: center;

}
</style>
